import { checkboxCardStyles } from './checkbox-card.styles';
import { CheckboxOptions, NatGenCheckbox, natGenCheckboxDefinition } from '../checkbox/checkbox';
import { checkboxCardTemplate } from './checkbox-card.template';
import { checkIcon, minusIcon } from '../../styles/icons';
import { applyMixins } from '../../foundation/apply-mixins';
import { StartEnd, StartEndOptions } from '../start-end/start-end';
import { NatGenDesignSystem } from '../../natgen-design-system';
import { attr, css, html, observable, render, when } from '@microsoft/fast-element';
import { checkboxTemplate } from '../checkbox/checkbox.template';
import { documentMediaSizeBehavior, DocumentMediaSizeMixin, MediaSize, mediaSizeBehavior, MediaSizeMixin, mediaSizes, relativeMediaSizeBehavior } from '../../utilities/media-size-observer';
import { RenderInstruction, renderWith } from '@microsoft/fast-element/render.js';
import { checkboxStyles } from '../checkbox/checkbox.styles';
import { display } from '../../foundation/display';
import { PropertyStyleSheetBehavior } from '../../foundation/property-stylesheet-behavior';
import { cardStyles } from '../card/card.styles';
import { selectableCardStyles } from '../../styles/patterns/selectable-card';

export type CheckboxCardOptions = CheckboxOptions & StartEndOptions;

/**
 * @element natgen-checkbox-card
 */
export class NatGenCheckboxCard extends NatGenCheckbox {

}

export const natGenCheckboxCardDefinition = NatGenCheckboxCard.compose({
    name: `${NatGenDesignSystem.prefix}-checkbox-card`,
    template: checkboxCardTemplate({
        checkedIndicator: checkIcon,
        indeterminateIndicator: minusIcon
    }),
    styles: checkboxCardStyles
});

applyMixins(NatGenCheckboxCard, StartEnd);

export class NatGenResponsiveCheckbox extends DocumentMediaSizeMixin(NatGenCheckboxCard) {
    documentMediaSizeChanged(newValue: MediaSize, oldValue: MediaSize): void {
        if (mediaSizes.indexOf(this.documentMediaSize) >= mediaSizes.indexOf('small')) {
            console.log('document media size changed big');
            this.$fastController.addStyles(cardStyles);
            this.$fastController.addStyles(selectableCardStyles);
            this.$fastController.template = checkboxCardTemplate({
                    checkedIndicator: checkIcon,
                    indeterminateIndicator: minusIcon
                });
        }
        else {
            console.log('document media size changed small');
            this.$fastController.removeStyles(cardStyles);
            this.$fastController.removeStyles(selectableCardStyles);
            this.$fastController.template = checkboxTemplate({
                    checkedIndicator: checkIcon,
                    indeterminateIndicator: minusIcon
                });
        }
    }

    @observable
    template: any;
}

export const natGenResponsiveCheckboxDefinition = NatGenResponsiveCheckbox.compose({
    name: `${NatGenDesignSystem.prefix}-responsive-checkbox`,
    styles: checkboxStyles
});
